import React from 'react'
import classNames from 'classnames'

const InputWrapper = ({
  iconLeft,
  error,
  iconRight,
  label,
  handleError = true,
  children,
  classes = {},
}) => {
  return (
    <div className={classNames('h-[100px] ',handleError && 'pb-2 ', 'w-full')}>
      {label && (
        <div className="text-[#422EAE] text-[18px] font-bold mb-2 text-left">
          {label}
        </div>
      )}
      <div className="flex justify-center items-center relative">
        {iconLeft && (
          <div
            className={classNames(
              'absolute inset-y-0 left-5 flex items-center justify-center',
              classes.iconsLeft,
            )}
          >
            {iconLeft}
          </div>
        )}
        {children}
        {iconRight && (
          <div
            className={classNames(
              'absolute inset-y-0 right-5 flex items-center justify-center',
              classes.iconRight,
            )}
          >
            <button type="button" className="focus:outline-none ">
              {iconRight}
            </button>
          </div>
        )}
      </div>
      {handleError && error && (
        <div
          className={classNames(
            'text-[12px] mt-1.5 h-5  text-left relative left-1 ',
            `text-[#EE443F]`,
          )}
        >
          {error}
        </div>
      )}
    </div>
  )
}

export default InputWrapper
